import ArrowDown from './ArrowDown.vue'
import ArrowLeft from './ArrowLeft.vue'
import ArrowRight from './ArrowRight.vue'
import ArrowUp from './ArrowUp.vue'
import ArrowsCrossed from './ArrowsCrossed.vue'
import Bell from './Bell.vue'
import Building from './Building.vue'
import Calendar from './Calendar.vue'
import CalendarStar from './CalendarStar.vue'
import Car from './Car.vue'
import Card from './Card.vue'
import CardAdd from './CardAdd.vue'
import Chart from './Chart.vue'
import ChartUp from './ChartUp.vue'
import Check from './Check.vue'
import CheckFail from './CheckFail.vue'
import CheckSuccess from './CheckSuccess.vue'
import CheckUnchecked from './CheckUnchecked.vue'
import ChevronDoubleDown from './ChevronDoubleDown.vue'
import ChevronDoubleLeft from './ChevronDoubleLeft.vue'
import ChevronDoubleRight from './ChevronDoubleRight.vue'
import ChevronDoubleUp from './ChevronDoubleUp.vue'
import ChevronDown from './ChevronDown.vue'
import ChevronLeft from './ChevronLeft.vue'
import ChevronRight from './ChevronRight.vue'
import ChevronUp from './ChevronUp.vue'
import Chronograph from './Chronograph.vue'
import Clock from './Clock.vue'
import Clover from './Clover.vue'
import Copy from './Copy.vue'
import Cross from './Cross.vue'
import Cup from './Cup.vue'
import Cuttlery from './Cuttlery.vue'
import Devices from './Devices.vue'
import Enter from './Enter.vue'
import ExclamationMark from './ExclamationMark.vue'
import EyeCrossed from './EyeCrossed.vue'
import EyeDefault from './EyeDefault.vue'
import Gear from './Gear.vue'
import GlpCoin from './GlpCoin.vue'
import HandBox from './HandBox.vue'
import Heart from './Heart.vue'
import HeartHands from './HeartHands.vue'
import House from './House.vue'
import Info from './Info.vue'
import Journey from './Journey.vue'
import LiveSignal from './LiveSignal.vue'
import LoopDollar from './LoopDollar.vue'
import LoopEuro from './LoopEuro.vue'
import LoopPound from './LoopPound.vue'
import LoopStar from './LoopStar.vue'
import Mail from './Mail.vue'
import Megaphone from './Megaphone.vue'
import Menu from './Menu.vue'
import Minus from './Minus.vue'
import MoneyBag from './MoneyBag.vue'
import MoneyNote from './MoneyNote.vue'
import Padlock from './Padlock.vue'
import Pencil from './Pencil.vue'
import PlanPlatinum from './PlanPlatinum.vue'
import PlanStandard from './PlanStandard.vue'
import PlanVip from './PlanVip.vue'
import Plus from './Plus.vue'
import PrizeBox from './PrizeBox.vue'
import PrizeLightning from './PrizeLightning.vue'
import PrizePack from './PrizePack.vue'
import PrizeSpin from './PrizeSpin.vue'
import QuestionDialogue from './QuestionDialogue.vue'
import QuestionMark from './QuestionMark.vue'
import Ribbon from './Ribbon.vue'
import Rocket from './Rocket.vue'
import Share from './Share.vue'
import SoundMute from './SoundMute.vue'
import SoundOn from './SoundOn.vue'
import Sparkle from './Sparkle.vue'
import Standings from './Standings.vue'
import Star from './Star.vue'
import Telephone from './Telephone.vue'
import Ticket from './Ticket.vue'
import TicketCheck from './TicketCheck.vue'
import TicketDiscount from './TicketDiscount.vue'
import TicketStar from './TicketStar.vue'
import Transmission from './Transmission.vue'
import TrashCan from './TrashCan.vue'
import User from './User.vue'
import UserGear from './UserGear.vue'
import UserGroup from './UserGroup.vue'
import Wallet from './Wallet.vue'
import Watch from './Watch.vue'

export default {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowsCrossed,
  ArrowUp,
  Bell,
  Building,
  Calendar,
  CalendarStar,
  Car,
  Card,
  CardAdd,
  Chart,
  ChartUp,
  Check,
  CheckFail,
  CheckSuccess,
  CheckUnchecked,
  ChevronDoubleDown,
  ChevronDoubleLeft,
  ChevronDoubleRight,
  ChevronDoubleUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Chronograph,
  Clock,
  Clover,
  Copy,
  Cross,
  Cup,
  Cuttlery,
  Devices,
  Enter,
  ExclamationMark,
  EyeCrossed,
  EyeDefault,
  Gear,
  GlpCoin,
  HandBox,
  Heart,
  HeartHands,
  House,
  Info,
  Journey,
  LiveSignal,
  LoopDollar,
  LoopEuro,
  LoopPound,
  LoopStar,
  Mail,
  Megaphone,
  Menu,
  Minus,
  MoneyBag,
  MoneyNote,
  Padlock,
  Pencil,
  PlanPlatinum,
  PlanStandard,
  PlanVip,
  Plus,
  PrizeBox,
  PrizeLightning,
  PrizePack,
  PrizeSpin,
  QuestionDialogue,
  QuestionMark,
  Ribbon,
  Rocket,
  Share,
  SoundMute,
  SoundOn,
  Sparkle,
  Standings,
  Star,
  Telephone,
  Ticket,
  TicketCheck,
  TicketDiscount,
  TicketStar,
  Transmission,
  TrashCan,
  User,
  UserGear,
  UserGroup,
  Wallet,
  Watch,
} as const

export const helper = {
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowsCrossed: 'ArrowsCrossed',
  ArrowUp: 'ArrowUp',
  Bell: 'Bell',
  Building: 'Building',
  Calendar: 'Calendar',
  CalendarStar: 'CalendarStar',
  Car: 'Car',
  Card: 'Card',
  CardAdd: 'CardAdd',
  Chart: 'Chart',
  ChartUp: 'ChartUp',
  Check: 'Check',
  CheckFail: 'CheckFail',
  CheckSuccess: 'CheckSuccess',
  CheckUnchecked: 'CheckUnchecked',
  ChevronDoubleDown: 'ChevronDoubleDown',
  ChevronDoubleLeft: 'ChevronDoubleLeft',
  ChevronDoubleRight: 'ChevronDoubleRight',
  ChevronDoubleUp: 'ChevronDoubleUp',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  ChevronRight: 'ChevronRight',
  ChevronUp: 'ChevronUp',
  Chronograph: 'Chronograph',
  Clock: 'Clock',
  Clover: 'Clover',
  Copy: 'Copy',
  Cross: 'Cross',
  Cup: 'Cup',
  Cuttlery: 'Cuttlery',
  Devices: 'Devices',
  Enter: 'Enter',
  ExclamationMark: 'ExclamationMark',
  EyeCrossed: 'EyeCrossed',
  EyeDefault: 'EyeDefault',
  Gear: 'Gear',
  GlpCoin: 'GlpCoin',
  HandBox: 'HandBox',
  Heart: 'Heart',
  HeartHands: 'HeartHands',
  House: 'House',
  Info: 'Info',
  Journey: 'Journey',
  LiveSignal: 'LiveSignal',
  LoopDollar: 'LoopDollar',
  LoopEuro: 'LoopEuro',
  LoopPound: 'LoopPound',
  LoopStar: 'LoopStar',
  Mail: 'Mail',
  Megaphone: 'Megaphone',
  Menu: 'Menu',
  Minus: 'Minus',
  MoneyBag: 'MoneyBag',
  MoneyNote: 'MoneyNote',
  Padlock: 'Padlock',
  Pencil: 'Pencil',
  PlanPlatinum: 'PlanPlatinum',
  PlanStandard: 'PlanStandard',
  PlanVip: 'PlanVip',
  Plus: 'Plus',
  PrizeBox: 'PrizeBox',
  PrizeLightning: 'PrizeLightning',
  PrizePack: 'PrizePack',
  PrizeSpin: 'PrizeSpin',
  QuestionDialogue: 'QuestionDialogue',
  QuestionMark: 'QuestionMark',
  Ribbon: 'Ribbon',
  Rocket: 'Rocket',
  Share: 'Share',
  SoundMute: 'SoundMute',
  SoundOn: 'SoundOn',
  Sparkle: 'Sparkle',
  Standings: 'Standings',
  Star: 'Star',
  Telephone: 'Telephone',
  Ticket: 'Ticket',
  TicketCheck: 'TicketCheck',
  TicketDiscount: 'TicketDiscount',
  TicketStar: 'TicketStar',
  Transmission: 'Transmission',
  TrashCan: 'TrashCan',
  User: 'User',
  UserGear: 'UserGear',
  UserGroup: 'UserGroup',
  Wallet: 'Wallet',
  Watch: 'Watch',
} as const
